<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>账户管理</el-breadcrumb-item>
          <el-breadcrumb-item>修改密码</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="修改密码" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item label="当前账户" v-show="false">
                  {{ info.userName }}
                </el-form-item>
                <el-form-item prop="password" label="当前密码">
                  <el-input
                    show-password
                    v-model="model.password"
                    placeholder="必填，最少6位英文字母"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="newPassword" label="新密码">
                  <el-input
                    show-password
                    v-model="model.newPassword"
                    placeholder="必填，最少6位英文字母"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="confirmPassword" label="确认密码">
                  <el-input
                    show-password
                    v-model="model.confirmPassword"
                    placeholder="必填，最少6位英文字母"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";

export default {
  data() {
    return {
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      info: [], //用户信息
      model: {
        password: null,
        newPassword: null,
        confirmPassword: null,
        oldPassword: null,
      },
      rules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 128, message: "密码长度在至少6位", trigger: "blur" },
          {
            pattern: /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,20}$/,
            message: "请输入6-20位数字字母组合",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 128, message: "密码长度在至少6位", trigger: "blur" },
          {
            pattern: /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,20}$/,
            message: "请输入6-20位数字字母组合",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm"].validate((valid) => {
          if (valid) resolve();
        });
      });

      _this.model.oldPassword = _this.model.password;
      if (_this.model.newPassword != _this.model.confirmPassword) {
        _this.$message.warning("新密码与确认密码不一致！");
        return;
      }

      Promise.all([f1]).then(() => {
        AxiosAjax({
          method: "put",
          url: "/cabinet/user/updatePassword",
          data: _this.model,
          loading: true,
          successMsg: "修改密码已成功",
          success: function (res) {
            _this.$refs["editForm"].resetFields(); //重置表单
            window.localStorage.removeItem("access_token");
            localStorage.setItem("fx_menu_selected_id", "");
            window.localStorage.removeItem("refresh_token");
            window.location.href = "/login";
          },
        });
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Manager/Password.vue